import React, { useState, useEffect } from "react";
// Importaciones corregidas para MUI v5
import { TextField, Box } from '@mui/material';
import { putUsuarios } from '../api';
import FirmaFileUploader from '../components/FirmaFileUploader';
import './Perfil.css';

// Estilos definidos de forma moderna (usando objetos simples para el prop 'sx')
const inputStyle = { width: '100%', marginBottom: '16px' };

function Perfil() {
  const [data, setData] = useState([]);
  const [User, setUsuario] = useState({
    nombre: '', // Inicializamos para evitar que TextField pase de uncontrolled a controlled
  });

  useEffect(() => {
    const UsuarioActualJSON = localStorage.getItem('UsuarioActual')
    if (UsuarioActualJSON) {
      const UsuarioActual = JSON.parse(UsuarioActualJSON)
      setUsuario(UsuarioActual)
    }
  }, [])

  const handleChange = e => {
    const { name, value } = e.target;
    setUsuario(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const uploader = React.createRef();

  const peticionPut = async () => {
    const resp = await putUsuarios(User);
    // Lógica de actualización de estado si es necesaria
  }

  function enviarImagenFirma(e) {
    e.preventDefault();
    if (!uploader.current) return;

    // Actualizamos el objeto User con la firma
    const updatedUser = { ...User, firma: uploader.current.state.imageSrc };
    setUsuario(updatedUser);
    peticionPut();
  };

  return (
    <div className="container">
      <h3>Perfil de usuario</h3>
      <hr />
      {/* Usamos el prop 'sx' para estilos rápidos y limpios */}
      <TextField
        sx={inputStyle}
        label="Nombre"
        name="nombre"
        variant="outlined"
        onChange={handleChange}
        value={User.nombre || ''}
      />
      <br />
      <div className="firma-image">
        <FirmaFileUploader ref={uploader} />
        <button type="submit" onClick={enviarImagenFirma}>Subir firma</button>
      </div>
    </div>
  );
}

export default Perfil;